import React, { useState, useEffect } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Search, Check } from "lucide-react";

export function PersonSearchSelect({ onSelect, selected, testId = "person-search" }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!q || q.length < 2) { setResults([]); return; }
    let active = true;
    setLoading(true);
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get("/persons", { params: { q, page_size: 8 } });
        if (active) setResults(data.persons || []);
      } catch { if (active) setResults([]); }
      finally { if (active) setLoading(false); }
    }, 300);
    return () => { active = false; clearTimeout(t); };
  }, [q]);

  return (
    <div data-testid={testId}>
      <div className="relative">
        <Search className="absolute left-2.5 top-2.5 w-4 h-4 text-slate-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search people by name, email or ID…"
          className="pl-8" data-testid={`${testId}-input`} />
      </div>
      {selected && (
        <div className="mt-2 text-sm text-emerald-700" data-testid={`${testId}-selected`}>
          Selected: {selected.name} ({selected.human_id})
        </div>
      )}
      {q.length >= 2 && (
        <div className="mt-2 max-h-56 overflow-y-auto tr-scroll rounded-md border border-slate-200 divide-y divide-slate-100">
          {loading && <div className="px-3 py-2 text-sm text-slate-400">Searching…</div>}
          {!loading && results.length === 0 && <div className="px-3 py-2 text-sm text-slate-400">No matches</div>}
          {results.map((p) => (
            <button key={p.id} type="button" data-testid={`${testId}-option-${p.id}`}
              onClick={() => onSelect({ id: p.id, human_id: p.human_id, name: `${p.first_name || ""} ${p.last_name || ""}`.trim() })}
              className="w-full text-left px-3 py-2 text-sm hover:bg-slate-50 flex items-center justify-between">
              <span>{p.first_name} {p.last_name} <span className="text-slate-400">· {p.human_id}</span></span>
              {selected?.id === p.id && <Check className="w-4 h-4 text-emerald-600" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
